import {Link} from "react-router-dom";
import config from "@/config";
import React from "react";

export const NavItems = ({src,title}) => {
    return (
        <Link
            to={src}
            className="relative group hover:text-primary transition duration-300"
        >
            {title}
            <span className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
        </Link>
    )
}